import React from "react"
import autobind from "class-autobind"
import AppStateStore from "../../../stores/AppStateStore"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import { IResourcePlannerScheduleFilter, ISelectedFilterTemplateId, EDefaultFilterValues } from "../../../models"
import FilterTemplate from "../FilterTemplate"
import AddResourcePlannerScheduleFilterTemplateDialogContainer from "./AddResourcePlannerScheduleFilterTemplateDialogContainer"
import strings from "../../../localization/strings"
import * as api from "../../../api"
import * as utils from "../../../helpers/utils"

interface IProps {
    filterTemplates: IResourcePlannerScheduleFilter[]
    selectedFilterTemplateId: ISelectedFilterTemplateId
    handleChangeFilterTemplates(filterTemplates: IResourcePlannerScheduleFilter[]): void
    handleSelectFilterTemlate(selectedFilterTemplateId: ISelectedFilterTemplateId): void
}
interface IState {
}

export default class ResourcePlannerScheduleFilter extends React.Component<IProps, IState> {
    private AddResourcePlannerScheduleFilterTemplateDialogContainer
    constructor(props: IProps) {
        super(props)
        this.state = {

        }
        autobind(this)
    }

    handleAddFilter(name: string) {
        const filter: IResourcePlannerScheduleFilter = this.AddResourcePlannerScheduleFilterTemplateDialogContainer.state.filterData
        filter.Id = utils.guid()
        filter.Name = name
        this.props.handleChangeFilterTemplates([...this.props.filterTemplates, filter])
        AppStateStore.setProgressSnackbarContent("loading")
        api.addResourcePlannerScheduleFilter(AuthenticationStore.getLoggedInUser().Id, filter).then(() => {
            this.props.handleSelectFilterTemlate(filter.Id)
            AppStateStore.setProgressSnackbarContent(strings.Filter_Saved)
        })
    }

    handleUpdateFilter(name: string) {
        const filter: IResourcePlannerScheduleFilter = this.AddResourcePlannerScheduleFilterTemplateDialogContainer.state.filterData
        filter.Name = name
        this.props.handleChangeFilterTemplates(this.props.filterTemplates.map(i => i.Id === filter.Id ? filter : i))
        AppStateStore.setProgressSnackbarContent("loading")
        api.updateResourcePlannerScheduleFilter(AuthenticationStore.getLoggedInUser().Id, filter).then(() => {
            this.props.handleSelectFilterTemlate(filter.Id)
            AppStateStore.setProgressSnackbarContent(strings.Filter_Updated)
        })
    }

    handleDeleteFilter(filterId: string) {
        this.props.handleChangeFilterTemplates(this.props.filterTemplates.filter(i => i.Id !== filterId))
        AppStateStore.setProgressSnackbarContent("loading")
        api.deleteResourcePlannerScheduleFilter(AuthenticationStore.getLoggedInUser().Id, filterId).then(() => {
            this.props.handleSelectFilterTemlate(EDefaultFilterValues.NONE)
            AppStateStore.setProgressSnackbarContent(strings.Filter_Deleted)
        })
    }

    render() {
        const editFilterTemplate = (this.props.selectedFilterTemplateId === EDefaultFilterValues.CREATE_NEW || this.props.selectedFilterTemplateId === EDefaultFilterValues.NONE) ?
            null : this.props.filterTemplates.find(i => i.Id === this.props.selectedFilterTemplateId)
        return (
            <FilterTemplate
                addFilterTemplateLabel={strings.Create_New_Resource_Planner_Filter}
                editFilterTemplateLabel={strings.Edit_Resource_Planner_Filter}
                filterTemplates={this.props.filterTemplates}
                selectedFilterTemplateId={this.props.selectedFilterTemplateId}
                handleSelectFilterTemlate={this.props.handleSelectFilterTemlate}
                handleSave={name => editFilterTemplate ? this.handleUpdateFilter(name) : this.handleAddFilter(name)}
                handleDeleteFilterTemplate={this.handleDeleteFilter}
            >
                <AddResourcePlannerScheduleFilterTemplateDialogContainer
                    ref={item => this.AddResourcePlannerScheduleFilterTemplateDialogContainer = item}
                    editFilterTemplate={editFilterTemplate}
                />
            </FilterTemplate>
        )
    }
}
